let prodType = 1;// 1 表示 米粒 2 表示 阿芬奇
// 根据 process.env.HOST 的值判断当前是什么环境
// 命令：npm run build -- test ，process.env.HOST就设置为：'test'
let HOST = process.env.HOST;
// if(HOST==="afenqi")
// {
//   prodType=2;
// }

let webUrl='';//前端页面部署的地址
switch(HOST){
case 'dev':
webUrl="http://139.224.165.13:11002";
// webUrl="http://coach.test.milijiazhang.com";
// webUrl="http://org.test.milijiazhang.com:11008";
break;
case 'test':
// webUrl="http://org.test.milijiazhang.com";
webUrl="http://coach.test.milijiazhang.com";
break;
case 'prod':
// webUrl="http://org.milijiazhang.com";
webUrl="http://coach.milijiazhang.com";
break;
case 'afenqi':
prodType=2;
// webUrl="http://106.15.187.96:10002";
break;
default:
// webUrl="http://localhost:8080";
// webUrl="http://coach.test.milijiazhang.com";
webUrl="http://coach.test.milijiazhang.com";
}
let addressConfig={
  fileServerDomain: 'https://qiniu.milijiazhang.com/',
  webUrl:webUrl
}
let deployEnvirConfig=prodType;// 1 表示 米粒 2 表示 阿芬奇
export default{
    deployEnvirConfig,
    addressConfig,  
}


// WEBPACK FOOTER //
// ./src/base/staticConfig.js